//devel
// export const BASE='http://devifdb-be.tridz.in/';

//stage
// export const BASE='https://ifdb-be.tridz.in/';

//live
export const BASE = 'https://ibir-api.hbku.edu.qa/';

//test
// export const BASE='http://139.59.20.32/rifas/cis-rifas/web/';
